
export default {
  "id": 1,
  "grade": 3,
  "number": 1,
  "title": "日商簿記3級練習問題第1回",
  "questions": [
    {
        "id": 1,
        "number": 1,
        "subNumber": 1,
        "categoryId": 1,
        "content": "備品100円を購入し、代金は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "現金",
            "普通預金",
            "当座預金",
            "備品",
            "車両運搬具",
            "土地"
        ]
    },
    {
        "id": 2,
        "number": 1,
        "subNumber": 1,
        "categoryId": 2,
        "content": "A社から商品100円を仕入れ、代金は現金で支払った（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "仕入",
            "雑費",
            "小口現金",
            "消耗品費",
            "現金",
            "未払金"
        ]
    },
    {
        "id": 3,
        "number": 1,
        "subNumber": 1,
        "categoryId": 3,
        "content": "Ｘ社に原価100円の商品を150円で売り上げ、代金は現金で受け取った（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:150",
        "shiwakeRightAnswer": "売上:150",
        "kamokus": [
            "現金",
            "売上",
            "当座預金",
            "未収入金",
            "雑益",
            "繰越商品"
        ]
    },
    {
        "id": 4,
        "number": 1,
        "subNumber": 1,
        "categoryId": 4,
        "content": "仕入先A社から商品100円を仕入れ、代金は月末に支払うこととした。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "買掛金:100",
        "kamokus": [
            "当座預金",
            "仕入",
            "現金",
            "未払金",
            "買掛金",
            "借入金"
        ]
    },
    {
        "id": 5,
        "number": 2,
        "subNumber": 1,
        "categoryId": 4,
        "content": "月末になり、買掛金100円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "現金",
            "普通預金",
            "支払手形",
            "買掛金",
            "支払手数料",
            "未払金"
        ]
    },
    {
        "id": 6,
        "number": 3,
        "subNumber": 1,
        "categoryId": 4,
        "content": "得意先X社に商品150円を売り上げ、代金は月末に受け取ることとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:150",
        "shiwakeRightAnswer": "売上:150",
        "kamokus": [
            "当座預金",
            "前受金",
            "未収入金",
            "売上",
            "現金",
            "売掛金"
        ]
    },
    {
        "id": 7,
        "number": 4,
        "subNumber": 1,
        "categoryId": 4,
        "content": "月末になり、売掛金150円を現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:150",
        "shiwakeRightAnswer": "売掛金:150",
        "kamokus": [
            "クレジット売掛金",
            "普通預金",
            "売掛金",
            "仮払金",
            "当座預金",
            "現金"
        ]
    },
    {
        "id": 8,
        "number": 1,
        "subNumber": 1,
        "categoryId": 5,
        "content": "商品200円をクレジット払いの条件で売り上げた。なお、信販会社に対する手数料は販売代金の1％とし、販売時に計上する。",
        "lecture": "",
        "shiwakeLeftAnswer": "クレジット売掛金:198  支払手数料:2",
        "shiwakeRightAnswer": "売上:200",
        "kamokus": [
            "売上",
            "支払利息",
            "売掛金",
            "クレジット売掛金",
            "仕入",
            "支払手数料"
        ]
    },
    {
        "id": 9,
        "number": 2,
        "subNumber": 1,
        "categoryId": 5,
        "content": "クレジット払いで売り上げた商品代金198円が信販会社から入金され、現金として処理した。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:198",
        "shiwakeRightAnswer": "クレジット売掛金:198",
        "kamokus": [
            "未収入金",
            "現金",
            "受取手形",
            "当座預金",
            "電子記録債権",
            "クレジット売掛金"
        ]
    },
    {
        "id": 10,
        "number": 1,
        "subNumber": 1,
        "categoryId": 6,
        "content": "商品200円を売り上げ、代金は全国共通商品券を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取商品券:200",
        "shiwakeRightAnswer": "売上:200",
        "kamokus": [
            "受取手数料",
            "普通預金",
            "売上",
            "仮受金",
            "受取商品券",
            "仮払金"
        ]
    },
    {
        "id": 11,
        "number": 2,
        "subNumber": 1,
        "categoryId": 6,
        "content": "商品券200円を精算し、現金を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:200",
        "shiwakeRightAnswer": "受取商品券:200",
        "kamokus": [
            "受取商品券",
            "受取手形",
            "受取手数料",
            "現金過不足",
            "未収入金",
            "現金"
        ]
    },
    {
        "id": 12,
        "number": 1,
        "subNumber": 1,
        "categoryId": 7,
        "content": "さきに掛けで仕入れた商品のうち、品違いにつき10円分を返品した。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:10",
        "shiwakeRightAnswer": "仕入:10",
        "kamokus": [
            "仕入",
            "現金",
            "未払金",
            "売上",
            "前払金",
            "買掛金"
        ]
    },
    {
        "id": 13,
        "number": 2,
        "subNumber": 1,
        "categoryId": 7,
        "content": "さきに掛けで売り上げた商品のうち、品違いにつき10円分が返品された。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上:10",
        "shiwakeRightAnswer": "売掛金:10",
        "kamokus": [
            "売掛金",
            "仕入",
            "買掛金",
            "普通預金",
            "売上",
            "未収入金"
        ]
    },
    {
        "id": 14,
        "number": 1,
        "subNumber": 1,
        "categoryId": 8,
        "content": "A社より商品100円を掛けで仕入れた。当社負担の運送料10円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:110",
        "shiwakeRightAnswer": "買掛金:100  現金:10",
        "kamokus": [
            "現金",
            "発送費",
            "買掛金",
            "未払金",
            "仕入",
            "売掛金"
        ]
    },
    {
        "id": 15,
        "number": 2,
        "subNumber": 1,
        "categoryId": 8,
        "content": "A社より商品100円を掛けで仕入れた。A社負担の運送料10円を現金で支払った。運送料は立替金で処理する。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100  立替金:10",
        "shiwakeRightAnswer": "買掛金:100  現金:10",
        "kamokus": [
            "買掛金",
            "現金",
            "発送費",
            "仕入",
            "未払金",
            "立替金"
        ]
    },
    {
        "id": 16,
        "number": 3,
        "subNumber": 1,
        "categoryId": 8,
        "content": "A社より商品100円を掛けで仕入れた。A社負担の運送料10円を現金で支払った。運送料は買掛金から減額した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "買掛金:90  現金:10",
        "kamokus": [
            "現金",
            "発送費",
            "立替金",
            "買掛金",
            "未払金",
            "仕入"
        ]
    },
    {
        "id": 17,
        "number": 4,
        "subNumber": 1,
        "categoryId": 8,
        "content": "商品200円に送料20円（先方負担）を加算した合計額で売り上げ、代金は掛けとした。また、運送会社に送料20円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:220  発送費:20",
        "shiwakeRightAnswer": "売上:220  現金:20",
        "kamokus": [
            "発送費",
            "買掛金",
            "仕入",
            "現金",
            "売上",
            "売掛金"
        ]
    },
    {
        "id": 18,
        "number": 5,
        "subNumber": 1,
        "categoryId": 8,
        "content": "商品200円を売り上げ、代金は掛けとした。また、運送会社に送料20円（当社負担）を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:200  発送費:20",
        "shiwakeRightAnswer": "売上:200  現金:20",
        "kamokus": [
            "現金",
            "売上",
            "前受金",
            "売掛金",
            "発送費",
            "仕入"
        ]
    },
    {
        "id": 19,
        "number": 1,
        "subNumber": 1,
        "categoryId": 9,
        "content": "商品100円を注文し、手付金10円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "前払金:10",
        "shiwakeRightAnswer": "現金:10",
        "kamokus": [
            "当座預金",
            "前払金",
            "前受金",
            "仕入",
            "買掛金",
            "現金"
        ]
    },
    {
        "id": 20,
        "number": 2,
        "subNumber": 1,
        "categoryId": 9,
        "content": "注文した商品100円を受け取り、さきに支払っていた手付金10円を減額した残額90円は月末に支払うこととした。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "前払金:10  買掛金:90",
        "kamokus": [
            "前払金",
            "買掛金",
            "未払金",
            "仕入",
            "現金",
            "当座預金"
        ]
    },
    {
        "id": 21,
        "number": 3,
        "subNumber": 1,
        "categoryId": 9,
        "content": "商品100円の注文を受け、手付金として10円を現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:10",
        "shiwakeRightAnswer": "前受金:10",
        "kamokus": [
            "手付金",
            "前払金",
            "前受金",
            "売上",
            "現金",
            "売掛金"
        ]
    },
    {
        "id": 22,
        "number": 4,
        "subNumber": 1,
        "categoryId": 9,
        "content": "注文を受けた商品100円を発送し、さきに受け取っていた手付金10円を減額した残額90円は月末に受け取ることとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "前受金:10  売掛金:90",
        "shiwakeRightAnswer": "売上:100",
        "kamokus": [
            "売上",
            "未収入金",
            "売掛金",
            "現金",
            "前払金",
            "前受金"
        ]
    },
    {
        "id": 23,
        "number": 1,
        "subNumber": 1,
        "categoryId": 10,
        "content": "商品100円（税抜価額）を仕入れ、代金は消費税（税率は10％）とともに現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100  仮払消費税:10",
        "shiwakeRightAnswer": "現金:110",
        "kamokus": [
            "仕入",
            "現金",
            "仮受消費税",
            "未払消費税",
            "買掛金",
            "仮払消費税"
        ]
    },
    {
        "id": 24,
        "number": 2,
        "subNumber": 1,
        "categoryId": 10,
        "content": "商品300円（税抜価額）を売り上げ、代金は消費税（税率は10％）とともに現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:330",
        "shiwakeRightAnswer": "売上:300  仮受消費税:30",
        "kamokus": [
            "仮受消費税",
            "売上",
            "仮払消費税",
            "売掛金",
            "未収入金",
            "現金"
        ]
    },
    {
        "id": 25,
        "number": 3,
        "subNumber": 1,
        "categoryId": 10,
        "content": "決算日を迎えた。残高試算表には仮払消費税10円と仮受消費税30円が計上されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮受消費税:30",
        "shiwakeRightAnswer": "仮払消費税:10  未払消費税:20",
        "kamokus": [
            "未払消費税",
            "仮受消費税",
            "未払金",
            "仮払消費税",
            "仮払金",
            "仮受金"
        ]
    },
    {
        "id": 26,
        "number": 4,
        "subNumber": 1,
        "categoryId": 10,
        "content": "未払消費税20円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払消費税:20",
        "shiwakeRightAnswer": "現金:20",
        "kamokus": [
            "未払金",
            "仮払消費税",
            "現金",
            "仮受消費税",
            "仮受金",
            "未払消費税"
        ]
    },
    {
        "id": 27,
        "number": 1,
        "subNumber": 1,
        "categoryId": 11,
        "content": "X社に商品100円を売り上げ、代金はX社振出の小切手で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "売上:100",
        "kamokus": [
            "送金小切手",
            "当座預金",
            "普通預金",
            "売上",
            "仕入",
            "現金"
        ]
    },
    {
        "id": 28,
        "number": 2,
        "subNumber": 1,
        "categoryId": 11,
        "content": "Y社の売掛金100円の回収として、郵便為替証書を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "郵便為替証書",
            "当座預金",
            "現金",
            "普通預金",
            "売上",
            "売掛金"
        ]
    },
    {
        "id": 29,
        "number": 1,
        "subNumber": 1,
        "categoryId": 12,
        "content": "現金の帳簿残高は110円であるが、実際有高は100円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金過不足:10",
        "shiwakeRightAnswer": "現金:10",
        "kamokus": [
            "雑損",
            "仮払金",
            "雑益",
            "現金過不足",
            "普通預金",
            "現金"
        ]
    },
    {
        "id": 30,
        "number": 2,
        "subNumber": 1,
        "categoryId": 12,
        "content": "現金の帳簿残高は150円であるが、実際有高は200円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:50",
        "shiwakeRightAnswer": "現金過不足:50",
        "kamokus": [
            "現金",
            "雑益",
            "雑費",
            "普通預金",
            "雑損",
            "現金過不足"
        ]
    },
    {
        "id": 31,
        "number": 3,
        "subNumber": 1,
        "categoryId": 12,
        "content": "以前に、現金不足10円が生じていたため、借方に現金過不足を計上していたが、本日、そのうち8円は水道光熱費の記帳漏れであることが判明した。",
        "lecture": "",
        "shiwakeLeftAnswer": "水道光熱費:8",
        "shiwakeRightAnswer": "現金過不足:8",
        "kamokus": [
            "現金過不足",
            "雑損",
            "水道光熱費",
            "現金",
            "旅費交通費",
            "普通預金"
        ]
    },
    {
        "id": 32,
        "number": 4,
        "subNumber": 1,
        "categoryId": 12,
        "content": "以前に、現金過剰50円が生じていたため、貸方に現金過不足を計上していたが、本日、そのうち30円は売掛金の回収額であることが判明した。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金過不足:30",
        "shiwakeRightAnswer": "売掛金:30",
        "kamokus": [
            "現金",
            "現金過不足",
            "売掛金",
            "雑益",
            "普通預金",
            "未収入金"
        ]
    },
    {
        "id": 33,
        "number": 5,
        "subNumber": 1,
        "categoryId": 12,
        "content": "決算日において、現金過不足勘定の残高が2円（借方残高）であるが、その原因は不明である。",
        "lecture": "",
        "shiwakeLeftAnswer": "雑損:2",
        "shiwakeRightAnswer": "現金過不足:2",
        "kamokus": [
            "雑損",
            "現金",
            "現金過不足",
            "借入金",
            "雑益",
            "雑費"
        ]
    },
    {
        "id": 34,
        "number": 6,
        "subNumber": 1,
        "categoryId": 12,
        "content": "決算日において、現金過不足勘定の残高が20円（貸方残高）であるが、その原因は不明である。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金過不足:20",
        "shiwakeRightAnswer": "雑益:20",
        "kamokus": [
            "現金",
            "雑損",
            "普通預金",
            "現金過不足",
            "未払金",
            "雑益"
        ]
    },
    {
        "id": 35,
        "number": 7,
        "subNumber": 1,
        "categoryId": 12,
        "content": "決算時において現金の実査を行ったところ、20円不足していた。不足の原因は不明だったので、適当な勘定に振り替えることとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "雑損:20",
        "shiwakeRightAnswer": "現金:20",
        "kamokus": [
            "現金過不足",
            "現金",
            "雑益",
            "未払金",
            "雑損",
            "当座預金"
        ]
    },
    {
        "id": 36,
        "number": 1,
        "subNumber": 1,
        "categoryId": 13,
        "content": "現金100円を普通預金口座に預け入れた。",
        "lecture": "",
        "shiwakeLeftAnswer": "普通預金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "当座預金",
            "仮受金",
            "現金",
            "現金過不足",
            "普通預金",
            "雑益"
        ]
    },
    {
        "id": 37,
        "number": 2,
        "subNumber": 1,
        "categoryId": 13,
        "content": "普通預金口座から定期預金口座に200円を預け替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "定期預金:200",
        "shiwakeRightAnswer": "普通預金:200",
        "kamokus": [
            "普通預金",
            "当座預金",
            "現金",
            "定期預金",
            "未収入金",
            "現金過不足"
        ]
    },
    {
        "id": 38,
        "number": 3,
        "subNumber": 1,
        "categoryId": 13,
        "content": "S銀行の普通預金口座に現金100円を預け入れ、M銀行の普通預金口座に現金200円を預け入れた。",
        "lecture": "",
        "shiwakeLeftAnswer": "普通預金-S銀行:100  普通預金-M銀行:200",
        "shiwakeRightAnswer": "現金:300",
        "kamokus": [
            "現金",
            "当座預金",
            "普通預金-M銀行",
            "現金過不足",
            "定期預金",
            "普通預金-S銀行"
        ]
    },
    {
        "id": 39,
        "number": 1,
        "subNumber": 1,
        "categoryId": 14,
        "content": "M銀行と当座取引契約を結び、現金100円を当座預金口座に預け入れた。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "普通預金",
            "定期預金",
            "借入金",
            "当座借越",
            "現金",
            "当座預金"
        ]
    },
    {
        "id": 40,
        "number": 2,
        "subNumber": 1,
        "categoryId": 14,
        "content": "A社に対する買掛金100円を支払うため、小切手を振り出した。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "買掛金",
            "送金小切手",
            "売掛金",
            "当座預金",
            "普通預金",
            "現金"
        ]
    },
    {
        "id": 41,
        "number": 3,
        "subNumber": 1,
        "categoryId": 14,
        "content": "売掛金100円について、当社振出の小切手で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "当座預金",
            "現金",
            "売掛金",
            "送金小切手",
            "買掛金",
            "普通預金"
        ]
    },
    {
        "id": 42,
        "number": 1,
        "subNumber": 1,
        "categoryId": 15,
        "content": "A社に対する買掛金100円を支払うため、小切手を振り出した。当社の当座預金口座の残高は80円であったが、取引銀行と限度額200円の当座借越契約を結んでいる。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "現金",
            "当座借越",
            "当座預金",
            "借入金",
            "買掛金",
            "普通預金"
        ]
    },
    {
        "id": 43,
        "number": 2,
        "subNumber": 1,
        "categoryId": 15,
        "content": "決算日において、当座預金が20円の貸方残高であった。よって、当座借越勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:20",
        "shiwakeRightAnswer": "当座借越:20",
        "kamokus": [
            "当座預金",
            "現金",
            "当座借越",
            "買掛金",
            "普通預金",
            "売掛金"
        ]
    },
    {
        "id": 44,
        "number": 3,
        "subNumber": 1,
        "categoryId": 15,
        "content": "翌期首において、当座借越20円の再振替仕訳を行う。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座借越:20",
        "shiwakeRightAnswer": "当座預金:20",
        "kamokus": [
            "当座借越",
            "普通預金",
            "当座預金",
            "現金",
            "売掛金",
            "買掛金"
        ]
    },
    {
        "id": 45,
        "number": 1,
        "subNumber": 1,
        "categoryId": 16,
        "content": "会計係は小口係に小口現金100円を、小切手を振り出して前渡しした。",
        "lecture": "",
        "shiwakeLeftAnswer": "小口現金:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "当座預金",
            "仮払金",
            "通信費",
            "小口現金",
            "旅費交通費",
            "雑費"
        ]
    },
    {
        "id": 46,
        "number": 2,
        "subNumber": 1,
        "categoryId": 16,
        "content": "会計係は小口係から小口現金について、以下の支払報告を受けた。<br> タクシー代 40円 コピー用紙代 30円 切手代20円",
        "lecture": "",
        "shiwakeLeftAnswer": "旅費交通費:40  消耗品費:30  通信費:20",
        "shiwakeRightAnswer": "小口現金:90",
        "kamokus": [
            "通信費",
            "雑費",
            "消耗品費",
            "普通預金",
            "旅費交通費",
            "小口現金"
        ]
    },
    {
        "id": 47,
        "number": 3,
        "subNumber": 1,
        "categoryId": 16,
        "content": "会計係は小口係に、小切手90円を振り出して、小口現金を補給した。",
        "lecture": "",
        "shiwakeLeftAnswer": "小口現金:90",
        "shiwakeRightAnswer": "当座預金:90",
        "kamokus": [
            "小口現金",
            "送金小切手",
            "消耗品費",
            "普通預金",
            "仮払金",
            "当座預金"
        ]
    },
    {
        "id": 48,
        "number": 4,
        "subNumber": 1,
        "categoryId": 16,
        "content": "会計係は小口係から小口現金について、以下の支払報告を受け、ただちに小切手を振り出して小口現金を補給した。<br> タクシー代 40円 コピー用紙代 30円 切手代 20円",
        "lecture": "",
        "shiwakeLeftAnswer": "旅費交通費:40  消耗品費:30  通信費:20",
        "shiwakeRightAnswer": "当座預金:90",
        "kamokus": [
            "消耗品費",
            "雑費",
            "旅費交通費",
            "通信費",
            "当座預金",
            "小口現金"
        ]
    },
    {
        "id": 49,
        "number": 1,
        "subNumber": 1,
        "categoryId": 17,
        "content": "TO社はA社から商品100円を仕入れ、代金は約束手形を振り出した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "支払手形:100",
        "kamokus": [
            "未払金",
            "受取手形",
            "支払手数料",
            "支払手形",
            "支払利息",
            "仕入"
        ]
    },
    {
        "id": 50,
        "number": 2,
        "subNumber": 1,
        "categoryId": 17,
        "content": "約束手形100円の支払期日が到来し、当座預金口座から決済された旨の連絡を受けた。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払手形:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "支払手形",
            "現金",
            "当座預金",
            "普通預金",
            "仕入",
            "買掛金"
        ]
    },
    {
        "id": 51,
        "number": 3,
        "subNumber": 1,
        "categoryId": 17,
        "content": "A社はTO社に商品100円を売り上げ、代金はTO社振出の約束手形を受け取った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取手形:100",
        "shiwakeRightAnswer": "売上:100",
        "kamokus": [
            "現金",
            "前受金",
            "売上",
            "支払手形",
            "前払金",
            "受取手形"
        ]
    },
    {
        "id": 52,
        "number": 4,
        "subNumber": 1,
        "categoryId": 17,
        "content": "約束手形100円の支払期日が到来し、手形代金が当座預金口座に入金された。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "受取手形:100",
        "kamokus": [
            "当座預金",
            "普通預金",
            "現金",
            "支払手形",
            "受取手形",
            "定期預金"
        ]
    },
    {
        "id": 53,
        "number": 1,
        "subNumber": 1,
        "categoryId": 18,
        "content": "TO社はA社から商品100円を掛けで仕入れていたが、掛け代金の支払いに電子記録債務を用いることにし、取引銀行を通じて債務の発生記録を行い、A社は取引銀行からその通知を受けた。TO社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "電子記録債務:100",
        "kamokus": [
            "電子記録債権",
            "電子記録債務",
            "未払金",
            "仕入",
            "買掛金",
            "普通預金"
        ]
    },
    {
        "id": 54,
        "number": 2,
        "subNumber": 1,
        "categoryId": 18,
        "content": "TO社はA社から商品100円を掛けで仕入れていたが、掛け代金の支払いに電子記録債務を用いることにし、取引銀行を通じて債務の発生記録を行い、A社は取引銀行からその通知を受けた。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "電子記録債権:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "仕入",
            "売掛金",
            "電子記録債務",
            "当座預金",
            "買掛金",
            "電子記録債権"
        ]
    },
    {
        "id": 55,
        "number": 3,
        "subNumber": 1,
        "categoryId": 18,
        "content": "TO社は電子記録債務100円について、当座預金口座を通じて払込みを行った。",
        "lecture": "",
        "shiwakeLeftAnswer": "電子記録債務:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "当座預金",
            "普通預金",
            "電子記録債務",
            "電子記録債権",
            "現金",
            "買掛金"
        ]
    },
    {
        "id": 56,
        "number": 4,
        "subNumber": 1,
        "categoryId": 18,
        "content": "A社は電子記録債権100円について、A社の当座預金口座に払込みを受けた。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "電子記録債権:100",
        "kamokus": [
            "普通預金",
            "電子記録債権",
            "現金",
            "当座預金",
            "売掛金",
            "仮受金"
        ]
    },
    {
        "id": 57,
        "number": 1,
        "subNumber": 1,
        "categoryId": 19,
        "content": "TO社はA社に現金100円を貸し付けた。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸付金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "当座預金",
            "現金",
            "貸付金",
            "普通預金",
            "借入金",
            "定期預金"
        ]
    },
    {
        "id": 58,
        "number": 2,
        "subNumber": 1,
        "categoryId": 19,
        "content": "A社はTO社から現金100円を借り入れた。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "借入金:100",
        "kamokus": [
            "支払利息",
            "普通預金",
            "現金過不足",
            "現金",
            "貸付金",
            "借入金"
        ]
    },
    {
        "id": 59,
        "number": 3,
        "subNumber": 1,
        "categoryId": 19,
        "content": "TO社はA社から貸付金100円の返済を受け、利息5円とともに現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:105",
        "shiwakeRightAnswer": "貸付金:100  受取利息:5",
        "kamokus": [
            "現金",
            "貸付金",
            "支払利息",
            "借入金",
            "支払利息",
            "受取利息"
        ]
    },
    {
        "id": 60,
        "number": 4,
        "subNumber": 1,
        "categoryId": 19,
        "content": "A社はTO社に対する借入金100円を返済し、利息5円とともに現金で支払った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "借入金:100  支払利息:5",
        "shiwakeRightAnswer": "現金:105",
        "kamokus": [
            "支払利息",
            "借入金",
            "現金",
            "貸付金",
            "受取利息",
            "当座預金"
        ]
    },
    {
        "id": 61,
        "number": 5,
        "subNumber": 1,
        "categoryId": 19,
        "content": "A社はTO社に対する借入金100円を返済し、利息（年利率3％、借入期間8か月）とともに現金で支払った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "借入金:100  支払利息:2",
        "shiwakeRightAnswer": "現金:102",
        "kamokus": [
            "受取利息",
            "未払利息",
            "普通預金",
            "支払利息",
            "借入金",
            "現金"
        ]
    },
    {
        "id": 62,
        "number": 1,
        "subNumber": 1,
        "categoryId": 20,
        "content": "TO社はA社に現金100円を貸し付け、約束手形を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "手形貸付金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "手形貸付金",
            "現金",
            "受取手形",
            "普通預金",
            "当座預金",
            "手形借入金"
        ]
    },
    {
        "id": 63,
        "number": 2,
        "subNumber": 1,
        "categoryId": 20,
        "content": "A社はTO社から現金100円を借り入れ、約束手形を渡した。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "手形借入金:100",
        "kamokus": [
            "支払手形",
            "手形借入金",
            "現金",
            "当座預金",
            "普通預金",
            "当座借越"
        ]
    },
    {
        "id": 64,
        "number": 1,
        "subNumber": 1,
        "categoryId": 21,
        "content": "従業員の出張にあたり、旅費の概算額100円を現金で渡した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮払金:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "旅費交通費",
            "当座預金",
            "仮払金",
            "仮払法人税等",
            "現金",
            "前払金"
        ]
    },
    {
        "id": 65,
        "number": 2,
        "subNumber": 1,
        "categoryId": 21,
        "content": "従業員が出張から戻り、概算額100円のうち、旅費の残額20円を現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:20  旅費交通費:80",
        "shiwakeRightAnswer": "仮払金:100",
        "kamokus": [
            "現金",
            "仮払金",
            "仮受金",
            "旅費交通費",
            "前払金",
            "普通預金"
        ]
    },
    {
        "id": 66,
        "number": 1,
        "subNumber": 1,
        "categoryId": 22,
        "content": "当座預金口座にＸ社からの入金100円があったが、内容が不明である。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "仮受金:100",
        "kamokus": [
            "仮受金",
            "前受金",
            "現金",
            "当座預金",
            "普通預金",
            "仮払金"
        ]
    },
    {
        "id": 67,
        "number": 2,
        "subNumber": 1,
        "categoryId": 22,
        "content": "内容不明の入金100円は、Ｘ社から商品の注文を受けた際の手付金であることが判明した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮受金:100",
        "shiwakeRightAnswer": "前受金:100",
        "kamokus": [
            "前受金",
            "仮受金",
            "売上",
            "仮払金",
            "当座預金",
            "普通預金"
        ]
    },
    {
        "id": 68,
        "number": 1,
        "subNumber": 1,
        "categoryId": 23,
        "content": "従業員が負担すべき生命保険料20円を現金で立替払いした。",
        "lecture": "",
        "shiwakeLeftAnswer": "従業員立替金:20",
        "shiwakeRightAnswer": "現金:20",
        "kamokus": [
            "従業員立替金",
            "法定福利費",
            "所得税預り金",
            "現金",
            "社会保険料預り金",
            "給料"
        ]
    },
    {
        "id": 69,
        "number": 2,
        "subNumber": 1,
        "categoryId": 23,
        "content": "従業員の代わりに立替払いしていた20円を現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:20",
        "shiwakeRightAnswer": "従業員立替金:20",
        "kamokus": [
            "給料",
            "仮払金",
            "法定福利費",
            "従業員立替金",
            "前払金",
            "現金"
        ]
    },
    {
        "id": 70,
        "number": 1,
        "subNumber": 1,
        "categoryId": 24,
        "content": "給料総額100円のうち、源泉所得税10円と従業員負担分の社会保険料5円を差し引いた残額を、当座預金口座から従業員の普通預金口座に振り込んだ。",
        "lecture": "",
        "shiwakeLeftAnswer": "給料:100",
        "shiwakeRightAnswer": "所得税預り金:10  社会保険料預り金:5  当座預金:85",
        "kamokus": [
            "普通預金",
            "社会保険料預り金",
            "当座預金",
            "所得税預り金",
            "法定福利費",
            "給料"
        ]
    },
    {
        "id": 71,
        "number": 2,
        "subNumber": 1,
        "categoryId": 24,
        "content": "給料から天引きした源泉所得税10円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "所得税預り金:10",
        "shiwakeRightAnswer": "現金:10",
        "kamokus": [
            "所得税預り金",
            "前受金",
            "現金",
            "普通預金",
            "給料",
            "仮受金"
        ]
    },
    {
        "id": 72,
        "number": 3,
        "subNumber": 1,
        "categoryId": 24,
        "content": "給料から天引きした、従業員負担分の社会保険料5円と、会社負担分の社会保険料（従業員負担分と同額）を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "社会保険料預り金:5  法定福利費:5",
        "shiwakeRightAnswer": "現金:10",
        "kamokus": [
            "社会保険料預り金",
            "現金",
            "普通預金",
            "給料",
            "所得税預り金",
            "法定福利費"
        ]
    },
    {
        "id": 73,
        "number": 1,
        "subNumber": 1,
        "categoryId": 25,
        "content": "決算において、売掛金の期末残高100円について、2％の貸倒引当金を設定する。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸倒引当金繰入:2",
        "shiwakeRightAnswer": "貸倒引当金:2",
        "kamokus": [
            "売掛金",
            "貸倒引当金",
            "受取手形",
            "貸倒引当金繰入",
            "売上",
            "損益"
        ]
    },
    {
        "id": 74,
        "number": 2,
        "subNumber": 1,
        "categoryId": 25,
        "content": "決算において、売掛金の期末残高300円について、2％の貸倒引当金を差額補充法により設定する。なお、期末における貸倒引当金の残高は2円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸倒引当金繰入:4",
        "shiwakeRightAnswer": "貸倒引当金:4",
        "kamokus": [
            "受取手形",
            "貸倒損失",
            "売掛金",
            "借入金",
            "貸倒引当金繰入",
            "貸倒引当金"
        ]
    },
    {
        "id": 75,
        "number": 1,
        "subNumber": 1,
        "categoryId": 26,
        "content": "Y社に対する売掛金50円（前期に発生）が貸し倒れた。なお、貸倒引当金の残高は2円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸誰引当金:2  貸倒損失:48",
        "shiwakeRightAnswer": "売掛金:50",
        "kamokus": [
            "貸倒損失",
            "貸倒引当金繰入",
            "売掛金",
            "償却債権取立益",
            "貸誰引当金",
            "受取手形"
        ]
    },
    {
        "id": 76,
        "number": 2,
        "subNumber": 1,
        "categoryId": 26,
        "content": "Y社に対する売掛金50円（当期に発生）が貸し倒れた。なお、貸倒引当金の残高は2円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸倒損失:50",
        "shiwakeRightAnswer": "売掛金:50",
        "kamokus": [
            "貸誰引当金",
            "売掛金",
            "貸倒損失",
            "受取手形",
            "貸倒引当金繰入",
            "雑損"
        ]
    },
    {
        "id": 77,
        "number": 1,
        "subNumber": 1,
        "categoryId": 27,
        "content": "前期に貸倒れ処理したY社に対する売掛金50円のうち、10円を現金で回収した。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:10",
        "shiwakeRightAnswer": "償却債権取立益:10",
        "kamokus": [
            "貸倒損失",
            "売掛金",
            "普通預金",
            "現金",
            "償却債権取立益",
            "雑益"
        ]
    },
    {
        "id": 78,
        "number": 1,
        "subNumber": 1,
        "categoryId": 28,
        "content": "建物780円を購入し、不動産会社に対する手数料20円とともに小切手を振り出して支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物:800",
        "shiwakeRightAnswer": "当座預金:800",
        "kamokus": [
            "支払手数料",
            "当座預金",
            "支払利息",
            "備品",
            "建物",
            "現金"
        ]
    },
    {
        "id": 79,
        "number": 2,
        "subNumber": 1,
        "categoryId": 28,
        "content": "備品300円を購入し、代金は小切手を振り出して支払った。なお、設置費用10円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品:310",
        "shiwakeRightAnswer": "当座預金:300  現金:10",
        "kamokus": [
            "当座預金",
            "支払手数料",
            "現金",
            "発送費",
            "備品",
            "送金小切手"
        ]
    },
    {
        "id": 80,
        "number": 3,
        "subNumber": 1,
        "categoryId": 28,
        "content": "店舗用建物の修繕を行い、100円を現金で支払った。このうち40円は建物の価値を高めるための支出（資本的支出）で残額は建物の本来の機能を維持するための支出（収益的支出）である。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物:40  修繕費:60",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "現金",
            "修繕費",
            "未払金",
            "備品",
            "建物",
            "雑費"
        ]
    },
    {
        "id": 81,
        "number": 1,
        "subNumber": 1,
        "categoryId": 29,
        "content": "決算において、当期首に購入した備品（取得原価400円、耐用年数4年、残存価額は取得原価の10％）について定額法により減価償却を行う。なお、記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:90",
        "shiwakeRightAnswer": "備品減価償却累計額:90",
        "kamokus": [
            "減価償却費",
            "備品",
            "支払手数料",
            "固定資産売却損",
            "備品減価償却累計額",
            "修繕費"
        ]
    },
    {
        "id": 82,
        "number": 2,
        "subNumber": 1,
        "categoryId": 29,
        "content": "×2年3月31日の決算において、当期の8月1日に購入した備品（取得原価480円、耐用年数4年、残存価額は0円）について定額法により月割りで減価償却を行う。なお、記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:80",
        "shiwakeRightAnswer": "備品減価償却累計額:80",
        "kamokus": [
            "備品減価償却累計額",
            "修繕費",
            "減価償却費",
            "定期預金",
            "備品",
            "普通預金"
        ]
    },
    {
        "id": 83,
        "number": 1,
        "subNumber": 1,
        "categoryId": 30,
        "content": "当期首において、前期首に購入した備品（取得原価360円、減価償却累計額90円）を300円で売却し、代金は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:300  備品減価償却累計額:90",
        "shiwakeRightAnswer": "備品:360  固定資産売却益:30",
        "kamokus": [
            "備品",
            "備品減価償却累計額",
            "現金",
            "固定資産売却益",
            "固定資産売却損",
            "未収入金"
        ]
    },
    {
        "id": 84,
        "number": 2,
        "subNumber": 1,
        "categoryId": 30,
        "content": "当期首において、前期首に購入した備品（取得原価360円、減価償却累計額90円）を250円で売却し、代金は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:250  備品減価償却累計額:90  固定資産売却損:20",
        "shiwakeRightAnswer": "備品:360",
        "kamokus": [
            "未収入金",
            "備品",
            "備品減価償却累計額",
            "固定資産売却損",
            "固定資産売却益",
            "現金"
        ]
    },
    {
        "id": 85,
        "number": 3,
        "subNumber": 1,
        "categoryId": 30,
        "content": "当期末において、前期首に購入した備品（取得原価360円、減価償却累計額90円）を200円で売却し、代金は現金で受け取った。なお、当期分の減価償却費も定額法（残存価額は0円、耐用年数は4年）により計上すること。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:200  備品減価償却累計額:90  減価償却費:90",
        "shiwakeRightAnswer": "備品:360  固定資産売却益:20",
        "kamokus": [
            "備品",
            "現金",
            "固定資産売却益",
            "備品減価償却累計額",
            "減価償却費",
            "固定資産売却損"
        ]
    },
    {
        "id": 86,
        "number": 1,
        "subNumber": 1,
        "categoryId": 31,
        "content": "営業用の車両500円を購入し、代金は翌月末払いとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "車両運搬具:500",
        "shiwakeRightAnswer": "未払金:500",
        "kamokus": [
            "車両運搬具",
            "車両運搬具減価償却累計額",
            "仕入",
            "買掛金",
            "現金",
            "未払金"
        ]
    },
    {
        "id": 87,
        "number": 2,
        "subNumber": 1,
        "categoryId": 31,
        "content": "消耗品100円を購入し、代金は月末払いとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "消耗品費:100",
        "shiwakeRightAnswer": "未払金:100",
        "kamokus": [
            "未払金",
            "消耗品費",
            "未収入金",
            "現金",
            "買掛金",
            "雑費"
        ]
    },
    {
        "id": 88,
        "number": 3,
        "subNumber": 1,
        "categoryId": 31,
        "content": "当期首に営業用の車両（取得原価500円、減価償却累計額300円、記帳方法は間接法）を150円で売却し、代金は翌月末に受け取ることとした。",
        "lecture": "",
        "shiwakeLeftAnswer": "未収入金:150  車両運搬具減価償却累計額:300  固定資産売却損:50",
        "shiwakeRightAnswer": "車両運搬具:500",
        "kamokus": [
            "未収入金",
            "固定資産売却損",
            "車両運搬具",
            "車両運搬具減価償却累計額",
            "固定資産売却益",
            "減価償却費"
        ]
    },
    {
        "id": 89,
        "number": 1,
        "subNumber": 1,
        "categoryId": 32,
        "content": "店舗用物件を借り入れ、1か月分の家賃100円と敷金（家賃2か月分）を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払家賃:100  差入保証金:200",
        "shiwakeRightAnswer": "現金:300",
        "kamokus": [
            "前払金",
            "差入保証金",
            "仮払金",
            "借入金",
            "現金",
            "支払家賃"
        ]
    },
    {
        "id": 90,
        "number": 2,
        "subNumber": 1,
        "categoryId": 32,
        "content": "店舗用物件の賃貸借契約が終了し、差し入れていた敷金（200円）が返還された。なお、修繕費30円が差し引かれた金額が普通預金口座に入金された。",
        "lecture": "",
        "shiwakeLeftAnswer": "修繕費:30  普通預金:170",
        "shiwakeRightAnswer": "差入保証金:200",
        "kamokus": [
            "修繕費",
            "前払金",
            "差入保証金",
            "仮払金",
            "支払家賃",
            "普通預金"
        ]
    },
    {
        "id": 91,
        "number": 1,
        "subNumber": 1,
        "categoryId": 33,
        "content": "会社の設立にあたり、株式100株を1株あたり50円で発行し、全額が普通預金口座に払い込まれた。",
        "lecture": "",
        "shiwakeLeftAnswer": "普通預金:5000",
        "shiwakeRightAnswer": "資本金:5000",
        "kamokus": [
            "定期預金",
            "資本金",
            "当座預金",
            "普通預金",
            "現金",
            "借入金"
        ]
    },
    {
        "id": 92,
        "number": 1,
        "subNumber": 1,
        "categoryId": 34,
        "content": "増資のため、株式50株を1株あたり60円で発行し、全額が当座預金口座に払い込まれた。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:3000",
        "shiwakeRightAnswer": "資本金:3000",
        "kamokus": [
            "借入金",
            "定期預金",
            "普通預金",
            "当座預金",
            "仮受金",
            "資本金"
        ]
    },
    {
        "id": 93,
        "number": 1,
        "subNumber": 1,
        "categoryId": 35,
        "content": "コピー用紙100円を購入し、現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "消耗品費:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "雑費",
            "通信費",
            "現金",
            "仮払金",
            "未払金",
            "消耗品費"
        ]
    },
    {
        "id": 94,
        "number": 1,
        "subNumber": 1,
        "categoryId": 36,
        "content": "郵便切手100円と収入印紙200円を購入し、現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "通信費:100  租税公課:200",
        "shiwakeRightAnswer": "現金:300",
        "kamokus": [
            "租税公課",
            "旅費交通費",
            "消耗品費",
            "未払金",
            "通信費",
            "現金"
        ]
    },
    {
        "id": 95,
        "number": 2,
        "subNumber": 1,
        "categoryId": 36,
        "content": "決算日において、通信費として計上した郵便切手のうち20円と、租税公課として計上した収入印紙のうち30円は未使用である。",
        "lecture": "",
        "shiwakeLeftAnswer": "貯蔵品:50",
        "shiwakeRightAnswer": "通信費:20  租税公課:30",
        "kamokus": [
            "消耗品費",
            "租税公課",
            "未払金",
            "通信費",
            "現金",
            "貯蔵品"
        ]
    },
    {
        "id": 96,
        "number": 3,
        "subNumber": 1,
        "categoryId": 36,
        "content": "期首につき、貯蔵品50円（郵便切手20円、収入印紙30円）の再振替仕訳を行う。",
        "lecture": "",
        "shiwakeLeftAnswer": "通信費:20  租税公課:30",
        "shiwakeRightAnswer": "貯蔵品:50",
        "kamokus": [
            "貯蔵品",
            "未払利息",
            "租税公課",
            "未払金",
            "未収入金",
            "通信費"
        ]
    },
    {
        "id": 97,
        "number": 1,
        "subNumber": 1,
        "categoryId": 37,
        "content": "当期の2月1日にA社に対して現金600円（年利率2％、貸付期間6か月、返済日に利息を受け取る）を貸し付けた。本日（3月31日）、決算日につき、受取利息の未収計上を行う。",
        "lecture": "",
        "shiwakeLeftAnswer": "未収利息:2",
        "shiwakeRightAnswer": "受取利息:2",
        "kamokus": [
            "貸付金",
            "借入金",
            "現金",
            "未収利息",
            "支払利息",
            "受取利息"
        ]
    },
    {
        "id": 98,
        "number": 2,
        "subNumber": 1,
        "categoryId": 37,
        "content": "当期分の利息の未払額が2円ある。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払利息:2",
        "shiwakeRightAnswer": "未払利息:2",
        "kamokus": [
            "支払利息",
            "未収利息",
            "未収入金",
            "未払利息",
            "未払金",
            "借入金"
        ]
    },
    {
        "id": 99,
        "number": 1,
        "subNumber": 1,
        "categoryId": 38,
        "content": "当期の7月1日にB社に対して建物を貸し付け、1年分の家賃1,200円を受け取った。本日（3月31日）、決算日につき、家賃の前受処理を行う。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取家賃:300",
        "shiwakeRightAnswer": "前受家賃:300",
        "kamokus": [
            "支払家賃",
            "前受家賃",
            "前払家賃",
            "受取家賃",
            "現金",
            "未収入金"
        ]
    },
    {
        "id": 100,
        "number": 2,
        "subNumber": 1,
        "categoryId": 38,
        "content": "家賃の前払額が300円ある。",
        "lecture": "",
        "shiwakeLeftAnswer": "前払家賃:300",
        "shiwakeRightAnswer": "支払家賃:300",
        "kamokus": [
            "支払家賃",
            "前払金",
            "現金",
            "前払家賃",
            "受取家賃",
            "前受家賃"
        ]
    },
    {
        "id": 101,
        "number": 1,
        "subNumber": 1,
        "categoryId": 39,
        "content": "売掛金200円を現金で回収したが、誤って2,000円で処理していた。正しい仕訳にするための仕訳を答えなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:1800",
        "shiwakeRightAnswer": "現金:1800",
        "kamokus": [
            "現金",
            "普通預金",
            "受取手形",
            "売掛金",
            "売上",
            "買掛金"
        ]
    },
    {
        "id": 102,
        "number": 1,
        "subNumber": 1,
        "categoryId": 40,
        "content": "会計係に小口現金370円の支払報告があった。なお、内訳は電車代220円、文房具代100円、お茶菓子代50円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "旅費交通費:220  消耗品費:100  雑費:50",
        "shiwakeRightAnswer": "小口現金:370",
        "kamokus": [
            "旅費交通費",
            "小口現金",
            "消耗品費",
            "雑損",
            "雑費",
            "当座預金"
        ]
    },
    {
        "id": 103,
        "number": 2,
        "subNumber": 1,
        "categoryId": 40,
        "content": "先週使用した小口現金370円の補給を当座預金口座を通じて処理した。",
        "lecture": "",
        "shiwakeLeftAnswer": "小口現金:370",
        "shiwakeRightAnswer": "当座預金:370",
        "kamokus": [
            "普通預金",
            "雑費",
            "旅費交通費",
            "当座預金",
            "小口現金",
            "消耗品費"
        ]
    },
    {
        "id": 104,
        "number": 1,
        "subNumber": 1,
        "categoryId": 41,
        "content": "売掛金100円を現金で回収した。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "現金",
            "買掛金",
            "受取手形",
            "現金過不足",
            "売掛金",
            "支払手形"
        ]
    },
    {
        "id": 105,
        "number": 2,
        "subNumber": 1,
        "categoryId": 41,
        "content": "電車代100円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "旅費交通費:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "消耗品費",
            "雑費",
            "普通預金",
            "現金",
            "旅費交通費",
            "支払手数料"
        ]
    },
    {
        "id": 106,
        "number": 3,
        "subNumber": 1,
        "categoryId": 41,
        "content": "買掛金100円を当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "買掛金",
            "売掛金",
            "当座預金",
            "普通預金",
            "支払手数料",
            "支払手形"
        ]
    },
    {
        "id": 107,
        "number": 1,
        "subNumber": 1,
        "categoryId": 42,
        "content": "決算において、売上原価を算定する。期首商品棚卸高は200円、期末商品棚卸高は100円であった。なお、売上原価は仕入勘定で算定する。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:200  繰越商品:100",
        "shiwakeRightAnswer": "繰越商品:200  仕入:100",
        "kamokus": [
            "買掛金",
            "売上原価",
            "支払手形",
            "売掛金",
            "繰越商品",
            "仕入"
        ]
    },
    {
        "id": 108,
        "number": 1,
        "subNumber": 1,
        "categoryId": 43,
        "content": "法人税等の中間申告で、1,000円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮払法人税等:1000",
        "shiwakeRightAnswer": "現金:1000",
        "kamokus": [
            "現金",
            "仮払法人税等",
            "未払法人税等",
            "法人税、住民税及び事業税",
            "仮払消費税",
            "租税公課"
        ]
    },
    {
        "id": 109,
        "number": 2,
        "subNumber": 1,
        "categoryId": 43,
        "content": "決算において、当期の法人税等が2,500円と確定した。なお、中間申告額1,000円は仮払法人税等で計上されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "法人税、住民税及び事業税:2500",
        "shiwakeRightAnswer": "仮払法人税等:1000  未払法人税等:1500",
        "kamokus": [
            "法人税、住民税及び事業税",
            "未払消費税",
            "仮払法人税等",
            "租税公課",
            "仮受消費税",
            "未払法人税等"
        ]
    },
    {
        "id": 110,
        "number": 3,
        "subNumber": 1,
        "categoryId": 43,
        "content": "未払法人税等1,500円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払法人税等:1500",
        "shiwakeRightAnswer": "現金:1500",
        "kamokus": [
            "未払法人税等",
            "現金",
            "未払金",
            "未払消費税",
            "仮払法人税等",
            "法人税、住民税及び事業税"
        ]
    },
    {
        "id": 111,
        "number": 1,
        "subNumber": 1,
        "categoryId": 44,
        "content": "当期純利益60円を損益勘定へ振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "損益:60",
        "shiwakeRightAnswer": "繰越利益剰余金:60",
        "kamokus": [
            "仕入",
            "繰越利益剰余金",
            "繰越商品",
            "損益",
            "雑損",
            "売上原価"
        ]
    },
    {
        "id": 112,
        "number": 2,
        "subNumber": 1,
        "categoryId": 44,
        "content": "当期純損失20円を損益勘定へ振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:20",
        "shiwakeRightAnswer": "損益:20",
        "kamokus": [
            "繰越利益剰余金",
            "繰越商品",
            "損益",
            "売上原価",
            "仕入",
            "雑損"
        ]
    },
    {
        "id": 113,
        "number": 1,
        "subNumber": 1,
        "categoryId": 45,
        "content": "株主総会において、繰越利益剰余金のうち株主配当金が100円と決定した。なお、利益準備金の計上額は10円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:110",
        "shiwakeRightAnswer": "未払配当金:100  利益準備金:10",
        "kamokus": [
            "未払配当金",
            "未払金",
            "未払法人税等",
            "繰越利益剰余金",
            "利益準備金",
            "借入金"
        ]
    },
    {
        "id": 114,
        "number": 2,
        "subNumber": 1,
        "categoryId": 45,
        "content": "株主総会で決定した株主配当金100円を当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払配当金:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "未払法人税等",
            "繰越利益剰余金",
            "利益準備金",
            "未払配当金",
            "現金",
            "当座預金"
        ]
    }
]
}